export default __webpack_public_path__ + "static/media/call-center.72c02b03.svg";